import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 14 14"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "stroke-linejoin": "round",
      d: "M12.647 2.06a.5.5 0 0 1 .853.354V13a.5.5 0 0 1-.5.5H2.414a.5.5 0 0 1-.353-.854z"
    }, null, -1),
    _createElementVNode("path", {
      "stroke-linecap": "round",
      d: "M5.586 9.121 7 10.536m.354-3.182 1.414 1.414m.354-3.182L10.536 7"
    }, null, -1)
  ]))]))
}
export default { render: render }